import { Button } from "zudoku/ui/Button";
import GithubIcon from "./icons/github";
import DiscordIcon from "./icons/discord";
import React from "react";

export default function HeaderIcon() {
  return (
    <div className="flex items-center border-r pr-2">
      <Button variant="ghost" size="icon" asChild>
        <a href="https://github.com/Lelapa-AI/" target="_blank">
          <GithubIcon className="w-4 h-4 dark:text-white" />
        </a>
      </Button>
      <Button variant="ghost" size="icon" asChild>
        <a href="https://discord.gg/QC6QJHasMP" target="_blank">
          <DiscordIcon className="w-5 h-5 dark:text-white" />
        </a>
      </Button>
    </div>
  );
}
